import CounterData from "./CounterData"

const ButcherData = () => (
    <CounterData counterType='butcher'/>
)

export default ButcherData